import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Router, Switch, useHistory, useRouteMatch } from "react-router";
import { RootStateType } from "../../redux-store/reducers";
import { useEffect, useState } from "react";
import { getApplicationDetails } from "../../redux-store/actions/application";
import { InvestorDetailsLayout } from "../investors/components";

import LoginRequireRoute from "../../routes/LoginRequireRoute";
import InvOnboardingLayout from "./InvOnboardingLayout";
import { Location } from 'history';
import { ApplicationProps } from "../../redux-store/types/api-types";
import DistributorDetails from "../investors/rmDetails";
import ContributorDetails from "../investors/personalDetails";
import RelatedPerson from "../investors/relatedPerson";
import ContactDetails from "../investors/contactDetails";
import AdditionalKYCDetails from "../investors/additionalKYCDetails";
import Fatca from "../investors/fatca";
import NomineeDetails from "../investors/nomineeDetails";
import riskProfile from "../investors/riskProfileDetails";
import ServicePreference from "../investors/servicePreferenceDetails";
import InvestmentPreference from "../investors/investmentPreferenceDetails";
import BankDetails from "../investors/bankDetails";
import DocumentDetails from "../investors/documentDetails";
import { showError } from "../../redux-store/actions/auth";
import { LinearProgress } from "@mui/material";

export const Routes = ({
    id,
    applicant1ReferenceId,
}: {
    id: string;
    applicant1ReferenceId?: string;
    applicationType?: string;
}): JSX.Element => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { path } = useRouteMatch();

    const [isApplicationLoading, setApplicationLoading] = useState<boolean>(false)

    const {
        auth: { role, token: authToken = "", diyInvestorOnboardingEdit = false },
        application: { application: _application },
        investor: { token = '' },
    } = useSelector((store: RootStateType) => store);

    const { applicationNumber } = _application || {};

    useEffect(() => {
        async function fetchApplication() {
            try {
                setApplicationLoading(true)
                // if (role === USER_ROLES.INVESTOR && !token) {
                //     history.push(`/investment-details/${applicant1ReferenceId}/investor-login`);
                //     return;
                // }
                if (id) {
                    (await dispatch(getApplicationDetails(id))) as unknown as ApplicationProps;
                } else {
                    // history.push('/');
                    console.log('No application id found');
                }
            } catch (e) {
                console.log((e as Error).message);
            } finally {
                setApplicationLoading(false)
            }
        }
        if (authToken) {
            fetchApplication();
        }
    }, [id]);

    if (isApplicationLoading || !id) {
        return <LinearProgress />
    }

    return (
        <InvestorDetailsLayout
            applicationId={id}
            applicant1ReferenceId={applicant1ReferenceId}
            applicationNumber={applicationNumber || ''}>
            <Router history={history}>
                <Switch>
                    <Route
                        exact
                        path={path}
                        render={() => (
                            <Redirect
                                to={{
                                    pathname: `${path}/personal-details`,
                                    state: { id, applicant1ReferenceId },
                                }}
                                from={location.pathname}
                            />
                        )}
                    />
                    <Route path={`${path}/rm-details`} component={DistributorDetails} />
                    <Route path={`${path}/personal-details`} component={ContributorDetails} />
                    <Route path={`${path}/related-person-details`} component={RelatedPerson} />
                    <Route path={`${path}/contact-details`} component={ContactDetails} />
                    <Route path={`${path}/additional-KYC-details`} component={AdditionalKYCDetails} />
                    <Route path={`${path}/fatca`} component={Fatca} />
                    <Route path={`${path}/nominee-details`} component={NomineeDetails} />
                    <Route path={`${path}/risk-profiles`} component={riskProfile} />
                    <Route path={`${path}/service-preference`} component={ServicePreference} />
                    <Route path={`${path}/investment-preference`} component={InvestmentPreference} />
                    <Route path={`${path}/bank-details`} component={BankDetails} />
                    <Route path={`${path}/document-details`} component={DocumentDetails} />
                    <LoginRequireRoute path="*" />
                </Switch>
            </Router>
        </InvestorDetailsLayout>
    );
};

export default function InvApplicationRoutes({
    location,
}: {
    location: Location<{ id: string; applicant1ReferenceId?: string; applicationType?: string }>;
}): JSX.Element {
    const { id = '', applicant1ReferenceId = '', applicationType = '' } = location.state || {};
    return (
        <InvOnboardingLayout>
            <Routes
                id={id}
                applicant1ReferenceId={applicant1ReferenceId}
                applicationType={applicationType}
            />
        </InvOnboardingLayout>
    )
}
